import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import RWNumberPicker from 'react-widgets/lib/NumberPicker';

/*
 * Component that extends the number picker from ReactWidgets.
 * Can be used outside React using custom events (`triggerEvents` prop).
 * You can disable the ability to have an empty value (`allowBlank` prop).
 */
export default class NumberPicker extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    defaultValue: PropTypes.number,
    value: PropTypes.number,
    min: PropTypes.number,
    className: PropTypes.string,
    allowBlank: PropTypes.bool,
    triggerEvents: PropTypes.bool,
  }

  static defaultProps = {
    allowBlank: true,
    triggerEvents: false,
    className: '',
  }

  constructor(props) {
    super(props);
    this.state = {
      currentValue: parseInt(this.props.value || this.props.defaultValue, 10) || (this.props.allowBlank ? null : 0),
    };
  }

  render() {
    const props = Object.assign({}, this.props);
    delete props.allowBlank;
    delete props.triggerEvents;

    if (typeof this.state.currentValue !== 'undefined') {
      props.value = this.state.currentValue;
    }

    return (
      <RWNumberPicker
        {...props}
        className={['NumberPicker'].concat(this.props.className).join(' ')}
        onChange={this.handleChange}
      />
    );
  }

  handleChange = (newValue) => {
    let value = newValue;

    if (!this.props.allowBlank && value === null) {
      value = this.props.min || 0;
    }

    // In the views you can listen to the custom event. You should use a parent
    // element if you want to bind before the react component is mounted.
    // The event is triggered before the value is updated. The new value is passed
    // with the event and is also available using `$node.data("new-value")`.
    if (this.props.triggerEvents) {
      const $node = $(ReactDOM.findDOMNode(this));
      $node.data('new-value', value);
      $node.trigger('numberpicker:change', [value]);
    }

    // You can pass a custom handler via props
    if (this.props.onChange) {
      this.props.onChange(value);
    }

    this.setState({ currentValue: value });
  }

  componentDidMount() {
    // For convenience, set the `new-value` data property before the first update
    if (this.props.triggerEvents) {
      const $node = $(ReactDOM.findDOMNode(this));
      $node.data('new-value', this.state.currentValue);
      $node.trigger('numberpicker:mounted', [this.state.currentValue]);
    }
  }
}
